import { Metrika } from '../components/metrika';
import { Analytics } from '../components/analytics';

export function burger() {
    const metrika = new Metrika;
    const analytics = new Analytics;

    let burgerBtn = document.querySelector('[am-block="burger"]'),
        burgerMenu = document.querySelector('[am-menu="burger"]'),
        citiesBurge = document.querySelector('[am-cities="burger"]'),
        headerPhoneMob = document.querySelector('[am-phone="header"][am-mob]');

    // Цели ям и га для телефона в шапке на мобильном
    headerPhoneMob.addEventListener('click', function() {
        metrika.reachGoal('PHONE_CLICK_HEDER', this);
        analytics.event('PHONE_CLICK_HEDER', this);
    });

    burgerBtn.addEventListener('click' , function() {
        metrika.reachGoal('CLICK_BURGER_MOBILE', this);
        analytics.event('CLICK_BURGER_MOBILE', this);

        if (citiesBurge.classList.contains('is-active')) {
            citiesBurge.classList.remove('is-active');

            if (!burgerMenu.classList.contains('is-active')) {
                this.classList.toggle('is-active');
            }

            const autoCityCheck = document.querySelector('[am-block="checkCity"]');
            if (autoCityCheck.classList.contains('is-active')) {
                autoCityCheck.classList.remove('is-active');
            }

        } else {
            this.classList.toggle('is-active');
            burgerMenu.classList.toggle('is-active');
        }

        document.addEventListener('click', function(e) {
            if (!e.target.closest('[am-section="header"]')) {
                burgerBtn.classList.remove('is-active');
                burgerMenu.classList.remove('is-active');
                citiesBurge.classList.remove('is-active');
            };
        });

    });
}
